import {
  Card,
} from "@material-tailwind/react";
import CountViewCard from "../../../components/cards/CountViewCard";

export function CardComp() {
  return (
    <Card className="mb-5">
      <CountViewCard />
    </Card>
  );
}
